import 'moment-holiday'
import moment from 'moment'
import holidays from './us-holidays'

type Moment = moment.Moment
export default function isHoliday (holidayMoment: Moment): number {
  const holidayName = holidayMoment.isHoliday() as string
  return holidays[holidayName] ?? -1
}
